(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sensol-air-explorer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('air-explorer')) {
  customElements.define('air-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-air-target]');
        if (!button) return;
        const target = this.querySelector('[id="' + button.dataset.airTarget + '"]');
        if (!target) return;
        this.querySelectorAll('details').forEach(detail => { detail.open = detail === target; });
        this.querySelectorAll('[data-air-target]').forEach(pin => pin.setAttribute('aria-pressed', String(pin === button)));
        target.querySelector('summary').focus({preventScroll:true});
      });
      this.querySelectorAll('details').forEach(detail => detail.addEventListener('toggle', () => {
        this.querySelectorAll('[data-air-target]').forEach(pin => {
          const panel = this.querySelector('[id="' + pin.dataset.airTarget + '"]');
          pin.setAttribute('aria-pressed', String(Boolean(panel && panel.open)));
        });
      }));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sensol-pro-explorer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pro-explorer')) {
  customElements.define('pro-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-pro-target]');
        if (!button) return;
        const target = this.querySelector('[id="' + button.dataset.proTarget + '"]');
        if (!target) return;
        this.querySelectorAll('details').forEach(detail => { detail.open = detail === target; });
        this.querySelectorAll('[data-pro-target]').forEach(pin => pin.setAttribute('aria-pressed', String(pin === button)));
        target.querySelector('summary').focus({preventScroll:true});
      });
      this.querySelectorAll('details').forEach(detail => detail.addEventListener('toggle', () => {
        this.querySelectorAll('[data-pro-target]').forEach(pin => {
          const panel = this.querySelector('[id="' + pin.dataset.proTarget + '"]');
          pin.setAttribute('aria-pressed', String(Boolean(panel && panel.open)));
        });
      }));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sensol-rs03-explorer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rs03-explorer')) {
  customElements.define('rs03-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-rs03-target]');
        if (!button) return;
        const target = this.querySelector('[id="' + button.dataset.rs03Target + '"]');
        if (!target) return;
        this.querySelectorAll('details').forEach(detail => { detail.open = detail === target; });
        this.querySelectorAll('[data-rs03-target]').forEach(pin => pin.setAttribute('aria-pressed', String(pin === button)));
        target.querySelector('summary').focus({preventScroll:true});
      });
      this.querySelectorAll('details').forEach(detail => detail.addEventListener('toggle', () => {
        this.querySelectorAll('[data-rs03-target]').forEach(pin => {
          const panel = this.querySelector('[id="' + pin.dataset.rs03Target + '"]');
          pin.setAttribute('aria-pressed', String(Boolean(panel && panel.open)));
        });
      }));
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
